// RoleCreate.tsx

import React, { useState, useEffect } from 'react';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import * as yup from 'yup';
import { Table, Switch, Checkbox, notification, Space, Collapse } from 'antd';
import { FaArrowLeft } from 'react-icons/fa';
import { connect } from 'react-redux';
import * as Actions from '../store/slices/role/roles'; // adjust path
import { FormInput } from '../components/Basic/FormInput';
import Button from '../components/Basic/button';
import style from '../pages/RoleManage/RoleManage.module.css';
import styles from './Form.module.css';

const { Panel } = Collapse;

interface FormValues {
  roleName: string;
  description: string;
  isActive: boolean;
}




const schema = yup.object({
  roleName: yup.string().trim().required('Role name is required'),
  description: yup.string().trim().required("Description Required"),
  isActive: yup.boolean().default(true),
})




interface Api {
  Permission: () => void;
  Role_Red: any;
  CreateRole: (payload: any) => unknown;
  UpdateRole: (id: number, payload: any) => unknown;
  getRole: (id: number) => unknown;
}

interface Props {
  Back: () => void;
  initialValues?: any;
  isEdit?: boolean;
  roleId?: number | string;
}



type RoleCreateProps = Api & Props;

const RoleCreate: React.FC<RoleCreateProps> = ({ Back, Permission, Role_Red, CreateRole, getRole, initialValues, isEdit = false, UpdateRole, roleId }) => {
  const [api, contextHolder] = notification.useNotification();
  const [selectedPermIds, setSelectedPermIds] = useState<number[]>([]);
  const [loading, setLoading] = useState(false);
  const [fetchingRole, setFetchingRole] = useState(isEdit);


  useEffect(() => {
    Permission();
  }, [Permission]);

  const rawPermissions = Role_Red?.Permission?.[0]?.res?.data || [];

  const ACTIONS = ["create", "update", "view", "delete", "approve", "reject"];

  const permissionTableData = Object.values(
    rawPermissions.reduce((acc: any, perm: any) => {
      const [module, action] = perm.name.split(":"); // e.g user:create

      if (!acc[module]) {
        acc[module] = {
          module,
          actions: {},
        };
      }

      acc[module].actions[action] = perm.permissionId;
      return acc;
    }, {})
  );





  const {
    control,
    handleSubmit,
    setValue,
    formState: { errors, isSubmitting },
    watch,
  } = useForm<FormValues>({
    resolver: yupResolver(schema),
    defaultValues: { roleName: '', description: '', isActive: true },
  });


useEffect(() => {
  if (isEdit && initialValues) {
    setValue('roleName', initialValues.name || '');
    setValue('description', initialValues.description || '');
    setValue('isActive', initialValues.isActive === true || (initialValues.isActive as any) === 'true' || initialValues.active === true || (initialValues.active as any) === 'true');

    if (roleId) {
      setFetchingRole(true);
      getRole(Number(roleId));
    }
  }
}, [ initialValues, roleId, setValue]);

useEffect(() => {
  const detailedRole = Role_Red?.getByID?.data;
  if (isEdit && detailedRole && fetchingRole) {
    const permIds = Array.isArray(detailedRole?.permissionIds)
      ? detailedRole.permissionIds.filter((id: any) => typeof id === 'number')
      : [];
    setSelectedPermIds(permIds);
    setFetchingRole(false);
  }
}, [Role_Red?.getByID?.data, isEdit, fetchingRole]);




  console.log(selectedPermIds)





  const onSubmit = handleSubmit(async (values) => {
    if (selectedPermIds.length === 0) {
      api.warning({ message: 'Please select at least one permission' });
      return;
    }
    setLoading(true);
    const payload = {
      name: values.roleName.trim(),
      description: values.description?.trim() || null,
      isActive: values.isActive,
      permissionIds: selectedPermIds,
    };
    try {
      if (isEdit && roleId) {
        await UpdateRole(Number(roleId), payload);
        api.success({ message: 'Role updated successfully' });
        
      } else {
        await CreateRole(payload);
        api.success({ message: 'Role created successfully' });
      }
      setTimeout(() => {
        window.location.reload()
      }, 2000);
    } catch (err: any) {
      api.error({
        message: isEdit ? 'Failed to update role' : 'Failed to create role',
        description: err?.message || String(err),
      });
    } finally {
      setLoading(false);
    }
  });




  const groupedPermissions = rawPermissions.reduce((acc: Record<string, any[]>, perm: any) => {
    const group = perm.pageGroup || 'Other';
    if (!acc[group]) acc[group] = [];
    acc[group].push(perm);
    return acc;
  }, {});

  const groupNames = Object.keys(groupedPermissions);
  const allSelected = selectedPermIds.length === rawPermissions.length;
  const someSelected = selectedPermIds.length > 0 && !allSelected;

  const handleSelectAll = (checked: boolean) => {
    if (checked) {
      setSelectedPermIds(rawPermissions.map((p: any) => p.permissionId));
    } else {
      setSelectedPermIds([]);
    }
  };



  const handleGroupSelectAll = (groupName: string, checked: boolean) => {
    const groupPerms = groupedPermissions[groupName].map((p: any) => p.permissionId);
    if (checked) {
      setSelectedPermIds(prev => {
        const set = new Set([...prev, ...groupPerms]);
        return Array.from(set);
      });
    } else {
      setSelectedPermIds(prev => prev.filter(id => !groupPerms.includes(id)));
    }
  };



  return (
    <>
      {contextHolder}

      <div className={style.Route}>
        <h5>
          <FaArrowLeft onClick={Back} style={{ cursor: 'pointer', marginRight: 8 }} />
          Role Management / Create Role
        </h5>

        <Space>
          <Button
            Text="Save"
            buttonClass={style.createBtn}
            onClick={onSubmit}
            // loading={loading || isSubmitting}
            Disable={loading || isSubmitting}
          />
          <Button Text="Cancel" onClick={Back} Disable={loading || isSubmitting} />
        </Space>
      </div>

      <div className={style.container}>
        {/* Role basic info */}
        <Space direction="vertical" style={{ width: '100%', marginBottom: 32 }}>
          <div style={{ display: 'flex', gap: 24, flexWrap: 'wrap' }}>
            <div className={styles.field} style={{ minWidth: 280 }}>
              <FormInput
                Label="Role Name"
                placeholder="e.g. Admin, Editor, Support Agent"
                name="roleName"
                control={control}
                errors={errors}
                classInput={style.Input}
                className={style.inputContainer}
                labelClass={style.Label}
                classError={style.Error}
              />
            </div>

            <div className={styles.field} style={{ minWidth: 340 }}>
              <FormInput
                Label="Description"
                placeholder="Optional role purpose"
                name="description"
                control={control}
                errors={errors}
                classInput={style.Input}
                className={style.inputContainer}
                labelClass={style.Label}
                classError={style.Error}
              />
            </div>

            <div style={{ paddingTop: 28, minWidth: 120 }}>
              <Space align="center">
                <Switch
                  checked={watch('isActive') === true}
                  
                  onChange={(v) => setValue('isActive', v)}
                />
                <span>Active</span>
              </Space>
            </div>
          </div>
        </Space>

        {/* Permissions */}
        <h4 style={{ margin: '0 0 16px' }}>Permissions</h4>

        <div style={{ marginBottom: 16 }}>
          <Checkbox
            indeterminate={someSelected}
            checked={allSelected}
            onChange={(e) => handleSelectAll(e.target.checked)}
          >
            Select All Permissions
          </Checkbox>
        </div>

        {/* <Collapse defaultActiveKey={groupNames} accordion={false}>
          {groupNames.map((groupName) => {
            const groupPerms = groupedPermissions[groupName];
            const groupIds = groupPerms.map((p: any) => p.permissionId);
            const selectedInGroup = groupIds.filter((id: number) => selectedPermIds.includes(id));
            const allInGroup = selectedInGroup.length === groupIds.length;
            const someInGroup = selectedInGroup.length > 0 && !allInGroup;
            const permissionMatrix = Object.values(
              rawPermissions.reduce((acc: any, perm: any) => {
                const [module, action] = perm.name.split(':');

                if (!acc[module]) {
                  acc[module] = {
                    module,
                    permissions: {},
                  };
                }

                acc[module].permissions[action] = perm.permissionId;
                return acc;
              }, {})
            );

            return (
              <Panel
                header={
                  <Space>
                    <Checkbox
                      indeterminate={someInGroup}
                      checked={allInGroup}
                      onChange={(e) => handleGroupSelectAll(groupName, e.target.checked)}
                      onClick={(e) => e.stopPropagation()}
                    />
                    {groupName} ({groupPerms.length})
                  </Space>
                }
                key={groupName}
              > */}
                <Table
                  dataSource={permissionTableData}
                  rowKey="module"
                  pagination={false}
                  bordered
                  size="middle"
                  columns={[
                    {
                      title: "Module",
                      dataIndex: "module",
                      fixed: "left",
                      render: (text) => <strong>{text.toUpperCase()}</strong>,
                    },

                    ...["create", "update", "view", "delete", "approve", "reject", "execute", "announce", "download", "save", "unlock", "cancel", "upsert", "rese_password"].map(action => ({
                      title: action.toUpperCase(),
                      align: "center" as const,
                      render: (_: any, record: any) => {
                        const permId = record.actions[action];

                        if (!permId) return "-";

                        return (
                          <Checkbox
                            checked={selectedPermIds.includes(permId)}
                            onChange={(e) => {
                              if (e.target.checked) {
                                setSelectedPermIds(prev => [...prev, permId]);
                              } else {
                                setSelectedPermIds(prev => prev.filter(id => id !== permId));
                              }
                            }}
                          />
                        );
                      },
                    })),
                  ]}
                />

              {/* </Panel>
            );
          })}
        </Collapse> */}

        <div style={{ marginTop: 16, color: '#888' }}>
          Selected: {selectedPermIds.length} / {rawPermissions.length}
        </div>
      </div>
    </>
  );
};

function mapStateToProps(state: any) {
  return { Role_Red: state.Role_Red };
}

export default connect(mapStateToProps, Actions)(RoleCreate);